// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__CeBoI","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1xZwI","obliqueLine":"membershipbadge_obliqueLine__ijet2"};